import React, { useEffect, useRef } from "react";
import { Map, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon from "../assets/marker-icon.png";
import markerIconOrange from "../assets/marker-icon-orange.png";
import MarkerClusterGroup from 'react-leaflet-markercluster';
import 'react-leaflet-markercluster/dist/styles.min.css';
import { Button } from "semantic-ui-react";
import { getColorEvent } from "./MobileViewLive";
import { numberToCharTG } from "../myfunctions";

const customMarker = new L.Icon({
  iconUrl: markerIcon,
  iconSize: [25, 41],
  iconAnchor: [13, 40],
});



function MapaApp({ dataInMap = [], selectedTournamentId, onMarkerClick }) {
  const mapRef = useRef(null);
  const clusterRef = useRef(null);

  const markersRef = useRef({});

  const selectedMarkerIcon = new L.Icon({
    iconUrl: markerIconOrange, // Przykład pomarańczowej pinezki
    iconSize: [25, 41],
    iconAnchor: [13, 40],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });

  // W komponencie:
  useEffect(() => {
    if (!mapRef.current) return;

    const timer = setTimeout(() => {
      const map = mapRef.current.leafletElement;
      map.setView([52.0693, 19.4803], 6); // środek Polski
    }, 100); // 2 sekundy

    // cleanup
    return () => clearTimeout(timer);
  }, []);

  // Funkcja do otwierania Google Maps
  const handleNavigation = (lat, lng, address) => {
    let url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
    if (address) {
      url = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;
    }
    window.open(url, "_blank");
  };

  useEffect(() => {
    const marker = markersRef.current[selectedTournamentId];
    const clusterGroup = clusterRef.current?.leafletElement;
    const map = mapRef.current?.leafletElement;

    if (marker && clusterGroup && map) {
      // 1. Dajemy 50ms na dokończenie re-renderu Reacta (zmiana ikony)
      setTimeout(() => {

        // 2. Jeśli ikony markerów się zmieniły, odświeżamy klastry
        if (clusterGroup.refreshClusters) {
          clusterGroup.refreshClusters();
        }

        // 3. Rozbijamy klaster i centrujemy
        clusterGroup.zoomToShowLayer(marker, () => {
          // Sprawdzamy, czy aktualny zoom nie jest już wystarczający
          // Jeśli chcesz zawsze 15, to wykonaj to BEZ animacji, żeby nie "szarpało"
          if (map.getZoom() < 15) {
            map.setZoom(15);
          }

          // Ważne: dajemy Leafletowi chwilę na narysowanie markera po rozbiciu klastra
          setTimeout(() => {
            marker.openPopup();
          }, 500);
        });
      }, 400);
    }
  }, [selectedTournamentId]);

  return (
    <Map
      style={{ height: "100%", width: "100%", borderRadius: 5 }}

      minZoom={6}   // minimalny zoom
      maxZoom={16}  // maksymalny zoom
      zoom={6}
      ref={mapRef}
    >
      <TileLayer
        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a>'
      />
      <MarkerClusterGroup ref={clusterRef} maxClusterRadius={1}>
        {dataInMap?.map((item) => {
          const place = JSON.parse(item.place);
          const isSelected = item.tournament_id === selectedTournamentId;

          return (
            <Marker
              key={item.tournament_id}
              // To jest kluczowe - zapisujemy instancję markera pod jego ID
              ref={(el) => {
                if (el) markersRef.current[item.tournament_id] = el.leafletElement;
              }}
              position={[parseFloat(place.lat), parseFloat(place.lng)]}
              icon={isSelected ? selectedMarkerIcon : customMarker}
              onClick={() => onMarkerClick(item.tournament_id)}
            >
              <Popup>
                <div style={{ minWidth: 200 }}>
                  <h4>{item.tournament_name}</h4>
                  <p style={{ margin: 0, padding: 0 }}><b>Organizator:</b> {item.organizer_name}</p>
                  <p style={{ margin: 0, padding: 0 }}><b>Miejsce:</b> {place.description}</p>
                  <p style={{ margin: 0, padding: 0 }}><b>Adres:</b> {place.address}</p>


                  {/* zdjęcie tylko jeśli istnieje */}
                  {item.img_file && (
                    <img
                      src={item.img_file}
                      alt={item.tournament_name}
                      style={{ width: "100%", borderRadius: "6px", marginTop: "5px" }}
                    />
                  )}

                  {/* przycisk do Google Maps */}


                  {/* Przycisk Główny Turnieju */}
                  {item.statusLive === 3 ? (
                    <Button
                      onClick={() => handleNavigation(place.lat, place.lng, place.address)}
                      fluid
                      style={{ marginTop: 5 }}
                      color="blue"
                      size="mini"
                    >
                      Nawiguj w Google Maps
                    </Button>) : ""}

                  <Button
                    color={getColorEvent(item.statusLive)}
                    size="small"
                    style={{ marginTop: 5 }}
                    icon
                    fluid
                    inverted
                    labelPosition='left'
                    onClick={() => window.location.href = ("https://tg-app.pl/tg/" + numberToCharTG(item.tournament_id))}
                  >
                    
                   
                    Szczegóły
                  </Button>


                  

                </div>
              </Popup>
            </Marker>
          );
        })}
      </MarkerClusterGroup>
    </Map>
  );
}

export default MapaApp;
